var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E375E",
    d: "M11.143 19.86V6.858h4.024c.154 0 .261.125.261.273v7.168c0 .149-.107.274-.253.274h-2.316v5.289c0 .148-.116.282-.27.282h-1.22c-.186-.01-.227-.124-.226-.282m-.857-5.289h-1.43a.29.29 0 0 1-.285-.264V7.13c0-.148.131-.273.285-.273h1.43zm0-9.43c0 .706.858 1.286 1.928 1.286s1.929-.58 1.929-1.285c0-.713-.86-1.285-1.929-1.285c-1.07 0-1.928.58-1.928 1.285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.f89e22f03a747cfb4e3b2e43b01a99b6.svg";
export { ForwardRef as ReactComponent };